// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width: 1025px) {
  .wrapper {
    width: 50vw;
  }
}
.subtitle {
  color: #6b6b6b;
  margin-top: 0.4em;
  margin-bottom: 1em;
}

.section-title {
  text-align: center;
  color: #9a9a9a;
  font-size: 12px;
  margin: 1.25em 0 0.75em;
}

.card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1em;
  border: 1px solid #e0e0e0;
  border-radius: 14px;
  padding: 0.9em 1em;
  margin-bottom: 0.75em;
  background: #fff;
}

.card-info {
  display: flex;
  flex-direction: column;
  gap: 0.15em;
  overflow: hidden;
}

.card-name {
  font-weight: 700;
  font-size: 15px;
}

.card-detail {
  font-size: 13px;
  color: #4a4a4a;
}

.select-button {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #cfcfcf;
  background: transparent;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.select-button .mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.add-new-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  color: #1a73e8;
  background: none;
  border: none;
  padding: 0.75em 0;
  margin: 0.5em auto 0;
  width: 100%;
  cursor: pointer;
  font-weight: 500;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
